import { render, staticRenderFns } from "./OdemeEmri51Taslak.vue?vue&type=template&id=f492c3f8"
import script from "./OdemeEmri51Taslak.vue?vue&type=script&lang=ts"
export * from "./OdemeEmri51Taslak.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports